<template>
  <div class="chart-shell">
    <canvas ref="chartCanvas" class="chart"></canvas>
  </div>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { Chart } from 'chart.js/auto';
import { cloneDeep } from 'lodash'; // Voegt lodash toe voor diepe kopieën

Chart.defaults.color = '#4d535c';
Chart.defaults.borderColor = '#d9dde0';
Chart.defaults.font.family = '"Fredoka", "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

export default {
  name: 'ChartComponent',
  props: {
    type: {
      type: String,
      required: true,
      default: 'bar',
    },
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup(props) {
    const chartCanvas = ref(null);
    let chartInstance = null;

    const renderChart = () => {
      if (chartInstance) {
        chartInstance.destroy();
      }

      if (chartCanvas.value) {
        // Gebruik diepe kopieën van data en opties om mutatie te voorkomen.
        const dataCopy = cloneDeep(props.data);
        const optionsCopy = cloneDeep(props.options) || {};

        optionsCopy.responsive = true;
        optionsCopy.maintainAspectRatio = false;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          optionsCopy.animation = false;
        }

        chartInstance = new Chart(chartCanvas.value, {
          type: props.type,
          data: dataCopy,
          options: optionsCopy,
        });
      }
    };

    onMounted(() => {
      renderChart();
    });

    onUnmounted(() => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    });

    watch(
      () => [props.type, props.data, props.options],
      () => {
        renderChart();
      },
      { deep: true }
    );

    return { chartCanvas };
  },
};
</script>

<style scoped>
.chart-shell {
  position: relative;
  width: min(100%, 56rem);
  height: clamp(17rem, 42vw, 25rem);
  margin-inline: auto;
}

.chart {
  width: 100% !important;
  height: 100% !important;
  max-width: 100%;
  max-height: 100%;
}

@media (max-width: 48rem) {
  .chart-shell {
    height: clamp(15rem, 68vw, 20rem);
  }
}
</style>
